import appApi from '../../../../../api/app-api';
import { toast } from 'react-toastify';
import globalCourseStore from '../../../../../stores/global-course-store';
import globalProgramStore from '../../../../../stores/program-store';

export const updateLectureRemoteStatusOperation = async (
  lectureId: number,
  isRemote: boolean,
  setIsLoading: (loading: boolean) => void,
) => {
  try {
    setIsLoading(true);
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourseId = globalCourseStore.getCurrentCourse()?.metadata.id;

    if (!currentProgramId || !currentCourseId) {
      toast.error('לא ניתן לעדכן את סטטוס ההרצאה - מידע חסר');
      setIsLoading(false);
      return;
    }

    // Get the current lecture to preserve the lecture name
    const lecture = globalCourseStore
      .getCurrentCourse()
      ?.details?.lectures?.find((lec) => lec.item.id === lectureId);

    if (!lecture) {
      toast.error('לא נמצאה הרצאה מתאימה');
      setIsLoading(false);
      return;
    }

    const lectureName = lecture.item.lectureName;

    // Update the lecture with the new isRemote status, preserving the name
    await appApi.updateLectureDetails(
      currentProgramId,
      currentCourseId,
      lectureId,
      lectureName,
      isRemote,
    );

    // Refresh the course details to update the UI
    await globalCourseStore.fetchCourseDetails(
      currentProgramId,
      currentCourseId,
    );
    setIsLoading(false);
    toast.success('סטטוס ההרצאה עודכן בהצלחה');
  } catch (e) {
    console.error(
      `updateLectureRemoteStatusOperation failed for lectureId: ${lectureId}, isRemote: ${isRemote} with error: ${e}`,
    );
    setIsLoading(false);
    toast.error('משהו קרה, לא ניתן לעדכן את סטטוס ההרצאה...');
  }
};
